export class TokenFilterModel {
    id;
    description = '';
    field = '';
    value = '';
}
//# sourceMappingURL=token-filter.js.map